<template>
<main class="container-1-1">
	<div class="container-header">
		<Breadcrumb
			v-bind:links="routesBread"
		>
		</Breadcrumb>
		<h2>Editar Documento</h2>
	</div>

	<div class="container-body">
		<label for="filename">Nombre</label>
		<input id="filename" v-model="doc.filename" type="text"
		name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required'"
		:placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

		<label for="description">Descripción</label>
		<input id="description" v-model="doc.description" type="text"
		name="descripción" :class="{'error' : errors.has('descripción') }" v-validate="'required'"
		:placeholder="[[errors.has('descripción') ? errors.first('descripción') : 'Ingresa una descripción']]"/>

		<label for="order">Orden</label>
		<input id="order" v-model="doc.order" type="number" min="0" step="1"
		name="orden" :class="{'error' : errors.has('orden')}" v-validate="'required|integer|min_value:0'"
		:placeholder="[[errors.has('orden') ? errors.first('orden') : 'Ingresa una ubicación en la lista de Ayuda (orden)']]"/>

		<div class="container-action-left" style="justify-content: start;">
			<button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
			<button class="btn btn-secondary" v-on:click="onClickGoNext()">Actualizar documento</button>
		</div>

			<div v-if="loading">
				Subiendo archivo...
			</div>

		<div v-if="errors.any() || validationMessage" class="validation-summary">
			<div v-if="validationMessage" class="validation-summary__message">
				{{ validationMessage }}
			</div>
			<div v-for="error in errors.items" :key="error.id" class="validation-summary__error">
				{{ error.msg }}
			</div>
		</div>
	</div>
</main>
</template>
<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import { restDocument } from '@/components/mixin/restDocument.js'

export default {
	name: 'DocumentsEdit',
	mixins: [restDocument],
	data () {
		return {
			actualFilename: '',
			deletePressed: false,
			validationMessage: '',
			loading: false,
		}
	},
	components: {
		Breadcrumb
	},
	computed: {
		routesBread: function (){
			return [
				{name: 'Documentos', path: '/documentos'},
				{name: this.doc.filename, path: '/documentos/' + this.$route.params.idDoc},
				{name: 'Editar Documento'},
			]
		}
	},
	props: [],
	methods: {
		onClickGoBack: function() {
			window.history.length > 1
				? this.$router.go(-1)
				: this.$router.push('/documentos/')
		},
		onClickGoNext: function() {
			this.$validator.validateAll().then(valid => {
				if (!valid) {
					this.validationMessage = 'Hay errores en el formulario.'
					return
				}
				this.loading = true
				this.putDoc()
			}).catch(() => {
				this.validationMessage = 'Ocurrió un error inesperado'
				this.loading = false
			})
		}
	},
	created () {
		this.$store.getters.getPermissions.documents ? true : this.$router.push('/pagina-no-encontrada')
	},
	mounted () {
		this.getDoc()
	}
}
</script>
<style lang="scss" scoped>
.validation-summary {
	margin-top: 1rem;
	padding: 1rem;
	border: 1px solid #dc3545;
	border-radius: 4px;
	background-color: #fff5f5;
}
.validation-summary__message {
	color: #dc3545;
	font-weight: 600;
	margin-bottom: 0.75rem;
}
.validation-summary__error {
	color: #dc3545;
	line-height: 1.5;
}
.validation-summary__error:not(:last-child) {
	margin-bottom: 0.25rem;
}
</style>
